/* eslint-disable camelcase */
/* eslint-disable max-lines-per-function */

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type InterestPointSocketProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  readonly message: any
  readonly translate?: (key: string) => string
  readonly reloadInterestPointList?: () => void
  readonly updateInterestPointRow?: (update: { readonly id: number; readonly expiration_date: string | null } | null) => void
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  readonly deleteMarker?: (markerType: string, markerId: number) => void
  readonly reloadInterestPointMarkers?: () => void
}

export default function interestPointSocket({
  message,
  reloadInterestPointList,
  updateInterestPointRow,
  deleteMarker,
  reloadInterestPointMarkers,
}: InterestPointSocketProps) {
  const { event_type, content } = message

  switch (event_type) {
    case 'INTEREST_POINT_CREATION':
      handleInterestPointCreation()
      break
    case 'INTEREST_POINT_VALIDATION':
      handleInterestPointValidation()
      break
    case 'INTEREST_POINT_EXPIRATION':
    case 'INTEREST_POINT_FORCED_EXPIRATION':
      handleInterestPointExpiration(content)
      break
    default:
      console.warn('Unknown interest point event type:', event_type)
  }

  function handleInterestPointCreation() {
    reloadInterestPointList?.()
  }

  function handleInterestPointValidation() {
    reloadInterestPointList?.()
    reloadInterestPointMarkers?.()
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function handleInterestPointExpiration(data: any) {
    if (deleteMarker && data.id) {
      deleteMarker('interestPoint', data.id)
    }

    updateInterestPointRow?.({ id: data.id, expiration_date: data.expiration_date ?? null })

    setTimeout(() => {
      reloadInterestPointList?.()
    }, 800)
  }
}

